import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import BarcodeIcon from 'mdi-material-ui/Barcode';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import { DeviceHelper } from '../../../helpers/deviceHelper';
import Tooltip from '@mui/material/Tooltip';
import isEmpty from '../../../is-empty';
import common from '../../../jsons/common.json';

export default function LabelPrintButton(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const security = useSelector(state => state.security.currentPath.print);
    const [enabled, setEnabled] = useState(true);
    const [multipleLabels, setMultipleLabels] = useState(false);
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const defaultDevice = useSelector(state => state.devices.defaultDevice);
    const hasRegisteredDevices = useSelector(state => state.devices.hasRegisteredDevices);
    const { containerData, lotLabel, plantLabel, printAmount, labelType } = props;

    const labelPrintTypes = common.labelPrintTypes;

    const openPrintDialog = (type, labelData) => {
        dispatch({
            type: 'TOGGLE_PRINTDIALOG',
            payload: { labelType: type, labelData }
        });
    };

    const handlePlantClick = () => {
        openPrintDialog(labelPrintTypes.plant, plantLabel);
    };

    const handleLotClick = () => {
        openPrintDialog(labelPrintTypes.lot, lotLabel);
    };

    const handleContainerClick = () => {
        openPrintDialog(labelType || labelPrintTypes.container, containerData);
    };

    useEffect(() => {
        let count = 0;
        if(!isEmpty(containerData))
            count++;
        if(!isEmpty(plantLabel))
            count++;
        if(!isEmpty(lotLabel))
            count++;
        if(count > 1)
            setMultipleLabels(true);
        else
            setMultipleLabels(false);
    }, [containerData, plantLabel, lotLabel]);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        };
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    if(multipleLabels) {
        return (
            <Tooltip title={'printLabels'} placement='top'>
                <div>
                    <IconButton
                        id="printIcon"
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        sx={{
                            borderRadius: '4px',
                            margin: 0,
                            padding: printAmount === 'single' ? 0.5 : 1,
                            color: 'primary.main',
                            minWidth: 0,
                        }}
                        disabled={!enabled && !security && !hasRegisteredDevices}
                        disableRipple={printAmount === 'single' ? true : false}
                        ref={anchorRef}
                    >
                        <BarcodeIcon />
                    </IconButton>
                    <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                        {...TransitionProps}
                        sx={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                            <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                {!isEmpty(plantLabel) && <MenuItem onClick={handlePlantClick}>{t('printPlantLabels')}</MenuItem>}
                                {!isEmpty(lotLabel) && <MenuItem onClick={handleLotClick}>{t('printLotLabels')}</MenuItem>}
                                {!isEmpty(containerData) && <MenuItem onClick={handleContainerClick}>{t('printAllContainerLabels')}</MenuItem>}
                            </MenuList>
                            </ClickAwayListener>
                        </Paper>
                        </Grow>
                    )}
                    </Popper>
                </div>
            </Tooltip>
        );
    }else {
        let onClick = null;
        let label = '';
        if(!isEmpty(plantLabel)){
            label = t('printPlantLabels');
            onClick = handlePlantClick;
        } else if(!isEmpty(lotLabel)) {
            label = t('printLotLabels');
            onClick = handleLotClick;
        } else if(!isEmpty(containerData)){
            label = t('printLabel');
            onClick = handleContainerClick;
        } else {
            label = t('noneFound');
            onClick = null;
        }
        return (
            <Tooltip title={label}>
                <div>
                    <IconButton onClick={onClick} id="printIcon" aria-haspopup="true"
                                sx={{ borderRadius: '4px', margin: 0,
                                    padding: (printAmount === 'single' ? 0.5 : 1),
                                    color: 'primary.main', minWidth: 0,
                                    }}
                                    disabled={!enabled && !security && !hasRegisteredDevices}
                                    disableRipple={printAmount === 'single' ? true : false} >
                        <BarcodeIcon />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}
